
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 32 32"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M18 5h2l-6 22h-2zM7.938 6.406l1.625 1.188L3.25 16l6.313 8.406-1.625 1.188-6.75-9L.75 16l.438-.594zm16.125 0l6.75 9 .438.594-.438.594-6.75 9-1.625-1.188L28.751 16l-6.313-8.406z"}})])
          )
        }
      }
    